/**
 * Menu item model
 * 
 * @class Model_Config
 * @extends Model
 */

Model_Config = ( function( Model ) {

	var Model_Config = function() {
		this.construct.apply( this, arguments );
	};

	$.extend( true, Model_Config.prototype, Model.prototype, {
		/**
		 * Construct object
		 * @constructor
		 */
		construct: function( attributes ) {
			this.data = {};
			this.init();
			this.parseData( attributes );
		},

		/**
		 * Initialize Model_Config
		 */
		init: function() {},

		parseData: function( data ) {
			var images, key, imageHref;

			this.data = {};

			if (CONFIG.resizeImagesByServer) {
				try { // map URLs to image resizer
					images = data.catalogue.images;

					for (key in images) {
						imageHref = ''; // replace base URL from API with CONFIG.imageResizerUrl
						imageHref += CONFIG.imageResizerUrl + images[key].href.substring(images[key].href.indexOf("{"));

						imageHref += '?quality=90'; // append quality query
						imageHref += getSizeQuery(key); // append requested size query
						imageHref += '&transform=true'; // append transform query

						images[key].href = imageHref; // replace original URL with just constructed for resizing images
					}
				}
				catch (e) {}
			}

			$.extend( true, this.data, data );

			function getSizeQuery(sizeString) {
				var requestedSizeQuery = '';

				switch (sizeString) {
					case 'tiny': requestedSizeQuery = ''; break; // used in search results - it's in exact size - don't resize
					case 'small': requestedSizeQuery = '&resize[]=183&resize[]=274'; break;
					case 'medium': requestedSizeQuery = '&resize[]=432&resize[]=648'; break;
					case 'carousel': requestedSizeQuery = '&resize[]=1280&resize[]=382'; break;
				}

				return requestedSizeQuery;
			}
		},


		/**
		 * @returns {Object}
		 */
		getConfig: function() {
			return this.data;
		},
		
		/**
		 * @returns {Object}
		 */
		getEvents: function() {
			return this.data.events;
		},

		/**
		 * @return {Number} offset server time - device time [ms]
		 */
		timeOffset: function() {
			return this.data.timeOffset;
		},

		/**
		 * @returns {String} URL
		 */
		urlHome: function() {
			return this.data.catalogue.home.href.replace( '{parentalGuidance}', API.config.PG );
		},

		urlSearch: function( query ) {
			return this.data.catalogue.search.href.replace( '{parentalGuidance}', API.config.PG ) + '?query=' + ( query || '' );
		},

		getSubsectionMovies: function( category ) {
			return this.data.catalogue.categories.movies.href.replace( '{parentalGuidance}', API.config.PG ).replace( '{category}', category );
		},
		getSubsectionTV: function( category ) {
			return this.data.catalogue.categories.tv.href.replace( '{parentalGuidance}', API.config.PG ).replace( '{category}', category );
		},

		getRelatedMovies: function( id ) {
			return this.data.catalogue.similar.movies.href.replace( '{parentalGuidance}', API.config.PG ).replace( '{contentKey}', id );
		},
		getRelatedTV: function( id ) {
			return this.data.catalogue.similar.tv.href.replace( '{parentalGuidance}', API.config.PG ).replace( '{contentKey}', id );
		},

		getDetailMovies: function( id ) {
			return this.data.catalogue.titles.movies.href.replace( '{parentalGuidance}', API.config.PG ).replace( '{contentKey}', id );
		},
		getDetailTV: function( id ) {
			return this.data.catalogue.titles.tv.href.replace( '{parentalGuidance}', API.config.PG ).replace( '{contentKey}', id );
		},

		getImageUrl: function( size, imagePackId ) {
			return this.data.catalogue.images[ size ].href.replace( '{imagePackId}', imagePackId );
		},

		urlStreams: function ( id ) {
			return this.data.media.streams.href.replace( '{assetId}', id );
		},

		urlAllSubtitles: function ( id ) {
			return this.data.media.allSubtitles.href.replace( '{assetId}', id );
		},

		urlSubtitles: function ( id, locale ) {
			return this.data.media.subtitles.href.replace( '{assetId}', id ).replace( '{locale}', locale );
		},

		urlProgress: function () {
			return this.data.progress.all.href;
		},

		urlProgressAsset: function ( id ) {
			return this.data.progress.asset.href.replace( '{assetId}', id );
		},

		urlProgressCategory: function ( id ) {
			return this.data.progress.category.href.replace( '{categoryId}', id );
		},

		urlProgressShow: function ( id ) {
			return this.data.progress.show.href.replace( '{showId}', id );
		},

		urlEvents: function () {
			return this.data.events.href;
		}

	} );

	return Model_Config;

} )( Model );



//////////////////
// WEBPACK FOOTER
// ./js/model/config.js
// module id = 45
// module chunks = 0